import {
  DAYJS_FORMAT,
  KitStatus,
  STATUS_BASED_ON_TIMELINE_MANAGEMENT,
  WorkflowTimeline,
} from '@/enums';
import { KitEntity } from '@/pages/privatePages/kit/types';
import { notification } from 'antd';
import dayjs from 'dayjs';
import i18next from 'i18next';
import { KitReceivedTitle } from './home/styles';
import { SortOrder } from '@/types';
import { kitStatusRequireForShotgunFlowIndicator } from '@/constants';

export const handleFailedMarkKitReceived = (data: Record<string, string[]>) => {
  notification.error({
    message: (
      <>
        {data?.failedKits?.length > 0 && (
          <>
            <KitReceivedTitle>{i18next.t('kit.failedKit')}</KitReceivedTitle>
            <div>
              {data?.failedKits.map((item: string, index: number) => (
                <div key={index}>{item.toUpperCase()}</div>
              ))}
            </div>
          </>
        )}
        {data?.receivedKitsData?.length > 0 && (
          <>
            <KitReceivedTitle>{i18next.t('kit.receivedKit')}</KitReceivedTitle>
            <div>
              {data.receivedKitsData.map((item: any, index: number) => (
                <div key={index}>
                  {`${item.kitSerial.toUpperCase()} received in lab on ${dayjs(
                    item.receivedDate,
                  ).format(DAYJS_FORMAT.FULL_DATE_FORMAT_2)}`}
                </div>
              ))}
            </div>
          </>
        )}
      </>
    ),
  });
};

export const getStatusHistory = (
  statusHistory: KitEntity['statusHistory'],
  status: KitStatus,
  order: SortOrder = 'DESC',
) => {
  return statusHistory
    ?.sort((a, b) =>
      order === 'ASC'
        ? dayjs(a?.createdAt).diff(dayjs(b?.createdAt))
        : dayjs(b?.createdAt).diff(dayjs(a?.createdAt)),
    )
    ?.find(history => history?.status === status);
};

export const getKitStatusHistory = (
  kit: KitEntity,
  status: KitStatus,
  order: SortOrder = 'DESC',
) => {
  return getStatusHistory(kit?.statusHistory, status, order);
};

export const checkPreKitForShotgun = ({
  preKit,
  channelTimeline,
}: {
  preKit?: KitEntity;
  channelTimeline?: WorkflowTimeline;
}) => {
  const preGhtKitStatus = preKit?.currentStatus?.status as KitStatus;
  const orderOfStatusesByChannelTimeline = channelTimeline
    ? STATUS_BASED_ON_TIMELINE_MANAGEMENT[channelTimeline]
    : undefined;

  return (
    orderOfStatusesByChannelTimeline &&
    preGhtKitStatus &&
    orderOfStatusesByChannelTimeline[preGhtKitStatus] >=
      orderOfStatusesByChannelTimeline[kitStatusRequireForShotgunFlowIndicator]
  );
};
